type ToastSuccessIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const ToastSuccessIcon = ({
  width = 21,
  height = 21,
  ...rest
}: ToastSuccessIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_6730_1280)">
      <path
        d="M7.875 8.75L10.5 11.375L18.375 2.625"
        stroke="#43875F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 2.15057C12.2964 1.89031 11.4145 1.75 10.5 1.75C5.66751 1.75 1.75 5.66751 1.75 10.5C1.75 15.3324 5.66751 19.25 10.5 19.25C15.3324 19.25 19.25 15.3324 19.25 10.5C19.25 9.58545 19.1097 8.70366 18.8494 7.875"
        stroke="#43875F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6730_1280">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

